import { useAppStore } from '../../../../store/appStore';
import { useMemo } from 'react';
import { ProjectData } from '../types';

const removeUnnecessaryWhitespaces = (str: string) => str.replace(/\s+/g, ' ');

export const useFilteredProjects = () => {
  const { missions, projectSearch } = useAppStore();

  return useMemo(() => {
    if (!missions) return [];

    const projects: ProjectData[] = missions.reduce((acc, customer) => {
      customer.sites.forEach((site) => {
        if (!projectSearch) {
          acc.push({ customer, site });
        } else {
          const fullName = removeUnnecessaryWhitespaces(
            customer.name.toLowerCase().trim() + ' ' + site.name.toLowerCase().trim(),
          );
          const cleanSearchString = removeUnnecessaryWhitespaces((projectSearch ?? '').toLowerCase().trim());

          if (fullName.includes(cleanSearchString)) {
            acc.push({ customer, site });
          }
        }
      });

      return acc;
    }, [] as ProjectData[]);

    projects.sort((a, b) => `${a.customer.name}${a.site.name}`.localeCompare(`${b.customer.name}${b.site.name}`));

    return projects;
  }, [missions, projectSearch]);
};
